module.exports = __webpack_public_path__ + "img/escalones-y-plataformas.8deb5dc4.jpg";